export const isSuperAdmin = (user) => {
  if (!user) return false;
  
  const role = user?.role;
  
  return role === 1;
};

export const isClinicAdmin = (user) => {
  if (!user) return false;
  const role = user?.role;
  return role === 2
};

export const isStaff = (user) => {
  if (!user) return false;
  const role = user?.role;
  return role === 3
};

// ---------- PERMISSION CHECK ----------
export const hasPermission = (user, permission) => {
  if (!user || !permission) return false;
  return Array.isArray(user.permissions) &&
    user.permissions.includes(permission);
};

// ---------- MULTIPLE PERMISSIONS ----------
export const hasAnyPermission = (user, permissions = []) => {
  if (!user || !Array.isArray(permissions)) return false;
  return permissions.some((p) => user.permissions?.includes(p));
};

export const hasAllPermissions = (user, permissions = []) => {
  if (!user || !Array.isArray(permissions)) return false;
  return permissions.every((p) => user.permissions?.includes(p));
};